import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SISComunicadoService from '@/services/Cadastros/Comunicado/SISComunicado.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sISComunicadoService = new SISComunicadoService();
  const refComunicadoListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'comunicadoid', label: 'Codigo', sortable: false },
    { key: 'comunicadotitulo_ptbr', label: 'Titulo PTBR', sortable: true },
    { key: 'comunicadoconteudo_ptbr', label: 'Conteudo PTBR', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalComunicado = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('comunicadoid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refComunicadoListTable.value ? refComunicadoListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalComunicado.value,
    };
  });

  const refetchData = () => {
    refComunicadoListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchComunicado = (ctx, callback) => {
    overlay.value = true;
    sISComunicadoService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalComunicado.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      const response = await sISComunicadoService.store(body);

      if (response || (response.status >= 200 && response.status < 300)) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Comunicado cadastrado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
        refetchData();
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Comunicado não foi cadastrado.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      }
    } catch (error) {
      console.log('ERRO: ', error);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: `${error}`,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };
  const Updated = async (body) => {
    await sISComunicadoService.update(body);
    refetchData();
  };

  const removerData = async (id) => {
    await sISComunicadoService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem ';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchComunicado,
    tableColumns,
    perPage,
    currentPage,
    totalComunicado,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refComunicadoListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
